import Services from "../components/Services";
import Process from "../components/Process";
import CTA from "../components/CTA";
import SectionTitle from "../components/common/SectionTitle";

const ServicesPage = () => {
	return (
		<div className="services-page">
			<section className="page-header">
				<div className="containerr pt-10">
					<h1>Our Services</h1>
					<p>Comprehensive IT solutions tailored to your business needs</p>
				</div>
			</section>

			<Services />

			<section className="technologies">
				<div className="container">
					<SectionTitle
						title="Technologies We Work With"
						subtitle="We're experts in the latest technologies"
					/>
					<div className="tech-grid">
						{/* Technology icons/logos would go here */}
						<div className="tech-item">
							<img src="/assets/images/tech-icons/react.png" alt="React" />
							<span>React</span>
						</div>
						<div className="tech-item">
							<img src="/assets/images/tech-icons/nodejs.png" alt="Node.js" />
							<span>Node.js</span>
						</div>
						<div className="tech-item">
							<img src="/assets/images/tech-icons/aws.png" alt="AWS" />
							<span>AWS</span>
						</div>
						<div className="tech-item">
							<img src="/assets/images/tech-icons/python.png" alt="Python" />
							<span>Python</span>
						</div>
						<div className="tech-item">
							<img src="/assets/images/tech-icons/docker.png" alt="Docker" />
							<span>Docker</span>
						</div>
						<div className="tech-item">
							<img
								src="/assets/images/tech-icons/tensorflow.png"
								alt="TensorFlow"
							/>
							<span>TensorFlow</span>
						</div>
					</div>
				</div>
			</section>

			<Process />
			<CTA />
		</div>
	);
};

export default ServicesPage;
